module.exports = "<div class=\"badge\" [style.background-color]=\"badge.color\">\n  <img [src]=\"getBadgeImage(badge)\" *ngIf=\"badge.shape\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/shared/badges/components/badge-component/badge.component.html
// module id = ../../../../../src/app/shared/badges/components/badge-component/badge.component.html
// module chunks = main